module.exports = __webpack_public_path__ + "static/media/2020.11.7“培育好家风 传承好家训”主题亲子活动.7cf5032b.jpg";